import { render } from "./upload.vue?vue&type=template&id=cb830a90&scoped=true"
import script from "./upload.vue?vue&type=script&lang=js"
export * from "./upload.vue?vue&type=script&lang=js"
script.render = render
script.__scopeId = "data-v-cb830a90"

export default script